export const AspectRatiosForDisplayAds = {
  Image300x250: {
    aspectRatio: 1.2,
    type: 'Image300x250',
    imagePreviewHeight: 75,
    simplifiedType: 'Image300x250',
    minSize: [300, 250],
  },
  Image728x90: {
    aspectRatio: 8.1,
    type: 'Image728x90',
    imagePreviewHeight: 75,
    simplifiedType: 'Image728x90',
    minSize: [728, 90],
  },
  Image160x600: {
    aspectRatio: 0.27,
    type: 'Image160x600',
    imagePreviewHeight: 75,
    simplifiedType: 'Image160x600',
    minSize: [160, 600],
  },
  Image300x600: {
    aspectRatio: 0.5,
    type: 'Image300x600',
    imagePreviewHeight: 75,
    simplifiedType: 'Image300x600',
    minSize: [300, 600],
  },
  Image120x600: {
    aspectRatio: 0.2,
    type: 'Image120x600',
    imagePreviewHeight: 75,
    simplifiedType: 'Image120x600',
    minSize: [120, 600],
  },
  Image468x60: {
    aspectRatio: 7.8,
    type: 'Image468x60',
    imagePreviewHeight: 75,
    simplifiedType: 'Image468x60',
    minSize: [468, 60],
  },
  Image336x280: {
    aspectRatio: 1.2,
    type: 'Image336x280',
    imagePreviewHeight: 75,
    simplifiedType: 'Image336x280',
    minSize: [336, 280],
  },
  Image250x250: {
    aspectRatio: 1,
    type: 'Image250x250',
    imagePreviewHeight: 75,
    simplifiedType: 'Image250x250',
    minSize: [250, 250],
  },
  Image180x150: {
    aspectRatio: 1.2,
    type: 'Image180x150',
    imagePreviewHeight: 75,
    simplifiedType: 'Image180x150',
    minSize: [180, 150],
  },
  Image970x250: {
    aspectRatio: 3.88,
    type: 'Image970x250',
    imagePreviewHeight: 75,
    simplifiedType: 'Image970x250',
    minSize: [970, 250],
  },
  Image234x60: {
    aspectRatio: 3.9,
    type: 'Image234x60',
    imagePreviewHeight: 75,
    simplifiedType: 'Image234x60',
    minSize: [234, 60],
  },
  Image970x90: {
    aspectRatio: 10.8,
    type: 'Image970x90',
    imagePreviewHeight: 75,
    simplifiedType: 'Image970x90',
    minSize: [970, 90],
  },

  Image320x50: {
    aspectRatio: 6.4,
    type: 'Image320x50',
    imagePreviewHeight: 75,
    simplifiedType: 'Image320x50',
    minSize: [320, 50],
  },
  Image300x50: {
    aspectRatio: 6,
    type: 'Image300x50',
    imagePreviewHeight: 75,
    simplifiedType: 'Image300x50',
    minSize: [300, 50],
  },
  Image320x480: {
    aspectRatio: 0.67,
    type: 'Image320x480',
    imagePreviewHeight: 75,
    simplifiedType: 'Image320x480',
    minSize: [320, 480],
  },
  Image480x320: {
    aspectRatio: 1.5,
    type: 'Image480x320',
    imagePreviewHeight: 75,
    simplifiedType: 'Image480x320',
    minSize: [480, 320],
  },
  Image320x100: {
    aspectRatio: 3.2,
    type: 'Image320x100',
    imagePreviewHeight: 75,
    simplifiedType: 'Image320x100',
    minSize: [320, 100],
  },
  Image216x36: {
    aspectRatio: 6,
    type: 'Image216x36',
    imagePreviewHeight: 75,
    simplifiedType: 'Image216x36',
    minSize: [216, 36],
  },
  Image168x28: {
    aspectRatio: 6,
    type: 'Image168x28',
    imagePreviewHeight: 75,
    simplifiedType: 'Image168x28',
    minSize: [168, 28],
  },
  Image120x20: {
    aspectRatio: 6,
    type: 'Image120x20',
    imagePreviewHeight: 75,
    simplifiedType: 'Image120x20',
    minSize: [120, 20],
  },
};
